<div class="full layout-col">
  <elder-table
    class="flex"
    [elderTableActivation]="{ autoActivation: 'always', autoActivateItem: 'first' }"
    matSort
    [data]="data"
    [idField]="'id'"
    [interactionMode]="'selection'"
    [selectionVisible]="true"
    [selectionMultiEnabled]="false"
  >
    <elder-data-toolbar
      *elderTableToolbar
      (requestNew)="onCreate($event)"
      (requestRemove)="onRemoveAll($event)"
      [canRemove]="true"
      [canAdd]="true"
      [canMore]="false"
    >
    </elder-data-toolbar>

    <!-- Day Offset -->
    <ng-container matColumnDef="dayOffset">
      <th mat-header-cell *matHeaderCellDef style="width: 40%" mat-sort-header="dayOffset">
        {{ 'optimization.day.dayOffset' | translate }}
      </th>
      <td mat-cell *matCellDef="let day; let i = index" class="py-sm">
        <mat-form-field subscriptSizing="dynamic" elderDense>
          <input
            matInput
            name="{{ 'dayIndex' + i }}"
            type="number"
            required
            min="0"
            pattern="[0-9]*"
            [(ngModel)]="day.dayOffset"
          />
          <mat-error elderValidationError></mat-error>
        </mat-form-field>
      </td>
    </ng-container>

    <!-- Frequency -->
    <ng-container matColumnDef="period">
      <th mat-header-cell *matHeaderCellDef style="width: 60%" mat-sort-header="period">
        {{ 'optimization.day.period' | translate }}
      </th>
      <td mat-cell *matCellDef="let day; let i = index">
        <mat-form-field subscriptSizing="dynamic" elderDense>
          <elder-duration-input
            placeholder="{{ 'optimization.day.period' | translate }}"
            [(isoValue)]="day.period"
            [format]="'hh:mm'"
          ></elder-duration-input>
          <mat-error elderValidationError></mat-error>
        </mat-form-field>
      </td>
    </ng-container>
  </elder-table>
</div>
